// ════════════════════════════════════════════════════════════════
// APP — Root component (config-driven entry point)
// ════════════════════════════════════════════════════════════════
//
// To deploy a NEW niche app:
// 1. Create a new AppConfig in src/config/app.config.ts
// 2. Import it here and pass to MasterShell
// 3. Everything else adapts automatically
//
// The Dashboard component receives the active widget from
// MasterShell and renders the appropriate view.
// ════════════════════════════════════════════════════════════════

import { useEffect } from 'react';
import { coldWalletConfig as config } from './config/app.config';
import { useVaultStore } from './stores/vaultStore';
import { useLicenseStore } from './stores/licenseStore';
import { useAutoLock } from './hooks/useAutoLock';
import { MasterShell } from './core/MasterShell';
import { Dashboard } from './components/Dashboard';
import { LockScreen } from './components/LockScreen';

export default function App() {
  const isUnlocked = useVaultStore((s) => s.isUnlocked);
  const checkInitialized = useVaultStore((s) => s.checkInitialized);
  const checkStoredLicense = useLicenseStore((s) => s.checkStoredLicense);

  // Auto-lock timer
  useAutoLock(config.security.autoLockMinutes);

  useEffect(() => {
    checkInitialized();
    checkStoredLicense();

    // Detect payment redirect from Stripe
    const params = new URLSearchParams(window.location.search);
    if (params.get('upgrade') === 'success') {
      const sessionId = params.get('session_id');
      if (sessionId) {
        useLicenseStore.getState().validateSession(sessionId, config.monetization.licenseWorkerUrl);
      }
      // Clean URL
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [checkInitialized, checkStoredLicense]);

  // Show lock screen if vault is not unlocked
  if (!isUnlocked) {
    return <LockScreen config={config} />;
  }

  // Show master shell with dashboard
  return (
    <MasterShell config={config}>
      {(activeWidget) => <Dashboard config={config} widget={activeWidget} />}
    </MasterShell>
  );
}
